/**
 * @module components/Skeleton
 * @description Q1314 Tier 2 loading skeletons: placeholder shapes in the exact
 * footprint of the featured strip and cause grid, so content lands without a
 * layout shift (Standard uses the brief's simple spinner instead).
 */
import type { JSX } from "react";
import { PAGE_SIZE } from "../config/page";
import "./Skeleton.css";

/** One skeleton cause card (same aspect and padding as CauseCard). */
function SkeletonCard(): JSX.Element {
    return (
        <div className="skeleton-card" aria-hidden="true">
            <div className="skeleton skeleton-card__media" />
            <div className="skeleton-card__body">
                <div className="skeleton skeleton--line skeleton--short" />
                <div className="skeleton skeleton--title" />
                <div className="skeleton skeleton--line" />
                <div className="skeleton skeleton--line" />
                <div className="skeleton skeleton--bar" />
                <div className="skeleton skeleton--button" />
            </div>
        </div>
    );
}

/** Skeleton for the featured strip + browse grid, announced once to screen readers. */
export function SkeletonBrowse(): JSX.Element {
    return (
        <div id="loading" className="container skeleton-browse" aria-busy="true">
            <p className="visually-hidden" role="status">Loading causes…</p>
            <div className="skeleton-browse__featured">
                {Array.from({ length: 3 }, (_, i: number) => <div key={i} className="skeleton skeleton-browse__feature" aria-hidden="true" />)}
            </div>
            <div className="skeleton-browse__grid">
                {Array.from({ length: PAGE_SIZE }, (_, i: number) => <SkeletonCard key={i} />)}
            </div>
        </div>
    );
}
